import React from "react";

function Integrations() {
  return <div></div>;
}

export default Integrations;
